<template>
    <div class="mt-5 mb-5">
        <div class="col-lg-12">
            <div class="d-flex justify-content-between align-items-center flex-sm-column flex-lg-row flex-md-row">
                <p class="title-biblioteca">
                    Noticias, eventos y comunicados
                </p>
            </div>
        </div>
        <!--  Inicio de carrusel -->
        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" :data-bs-slide-to="index"
                    :class="{ 'active': index === 0 }" :aria-label="'Slide' + index + 1" v-for="(img, index) in images"
                    :key="index"
                    style="border-radius: 5px; width: 35px; height: 8px; background-color: white!important;"></button>
            </div>
            <div class="carousel-inner">
                <div class="carousel-item" :class="{ 'active': index === 0 }" v-for="(img, index) in images" :key="index"
                    data-bs-interval="3000">
                    <img :src="img" class="d-block w-100" :alt="'Slide ' + (index + 1)">
                </div>
            </div>
            <button class="carousel-control-prev"
                style=" border: 2px solid white; height: 50px; width: 50px; border-radius: 50%; top:42% ; margin: 10px; padding: 5px;"
                type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next"
                style=" border: 2px solid white; height: 50px; width: 50px; border-radius: 50%; top:42% ; margin: 10px; padding: 5px;"
                type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
        <!-- Fin de carrusel -->
        <div class="row justify-content-end" style="background-color:#b8725a;  margin: 20px 1px;">
            <div class="col-12 col-md-6 col-lg-4">
                <a href="https://api.whatsapp.com/send?phone=34123456789&text=Hola!,%20Como%20puedo%20ayudarte?"
                    target="_blank"
                    style="text-decoration:none; color:#ffffff; border: 2px solid white; padding: 5px; min-width: 100px; "
                    class="d-flex justify-content-center align-items-center">
                    <i class="fab fa-whatsapp"  style="font-size: 24px; margin-right: 10px;"></i>
                    <p style="margin-bottom: 0;">WHATSAPP</p>
                </a>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <a href="mailto:contacto@hirembajadores.com" target="_blank"
                    style="text-decoration:none; color:#ffffff; border: 2px solid white; padding: 5px; min-width: 100px;"
                    class="d-flex justify-content-center align-items-center">
                    <i class="fas fa-envelope" style="font-size: 24px; margin-right: 10px;"></i>
                    <p style="margin-bottom: 0;"> CORREO ELECTRONICO</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            images: [
                "https://hircasageneral.blob.core.windows.net/embajadores-manager/img/videos/BIBLIOTECA VIRTUAL_01.png",
                "https://hircasageneral.blob.core.windows.net/embajadores-manager/img/videos/BIBLIOTECA VIRTUAL-02.png",
                "https://hircasageneral.blob.core.windows.net/embajadores-manager/img/videos/BIBLIOTECA VIRTUAL-03.png",
                "https://hircasageneral.blob.core.windows.net/embajadores-manager/img/videos/BIBLIOTECA VIRTUAL-04.png"
            ],
        }
    }
}
</script>

<style lang="scss" scoped>

.button {
  background-color: #b8725a !important;
  color: white;
  border-radius: 5px;
  border: 0;
  font-size: 14px;
  padding: 10px;
  max-width: 300px;
  text-decoration: none;
}
.title{
    font-size: 24px; font-weight: bold; margin-bottom: 0;
}

@media only screen and (max-width: 1024px) {

.title{
    font-size: 18px;
}

}
</style>